export const multiItemFlightSearchCriteria = [
  'origin',
  'cabinClass',
  'tripType',
  'airlineCode',
  'directFlights',
  'infantsInSeats',
  'partialStayStartDate',
  'partialStayEndDate',
  'partialStay',
];
export const multiItemCarSearchCriteria = ['pickUpTime', 'dropOffTime', 'driverAge'];
export const multiItemCompleteSearchCriteria = multiItemCarSearchCriteria.concat(multiItemFlightSearchCriteria);
